module.exports = __webpack_public_path__ + "static/media/Affirm_Logo.e89eeb32.svg";